/**
 * @generated SignedSource<<af820c10c1d5f40768a6ae628c25af63>>
 * @relayHash 7f4627e7f6d67eda31ee8e2f77d77e7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0d71ec8de0783e140eaed5179e3d8fe3bc2ac9265cc778c0c0c9de6f064874b5

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FilterRefinementTimelineQuery } from './FilterRefinementTimelineQuery.graphql';

const node: PreloadableConcreteRequest<FilterRefinementTimelineQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0d71ec8de0783e140eaed5179e3d8fe3bc2ac9265cc778c0c0c9de6f064874b5",
    "metadata": {},
    "name": "FilterRefinementTimelineQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
